import { isProduction } from './getEnvironment';

export const BUCKET_PREFIX = import.meta.env.VITE_S3_BUCKET_PREFIX;
export const ENVIRONMENT = isProduction ? 'production' : 'development';

export const BRAND = 'crowncoins';
